interface AuthError {
  code: string;
}

export function isAuthError(err: unknown): err is AuthError {
  return (
    typeof err === 'object' &&
    err !== null &&
    'code' in err &&
    typeof (err as { code?: unknown }).code === 'string'
  );
}

export function computeZodiac(dateStr: string): string {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '';

  const month = d.getMonth() + 1;
  const day = d.getDate();
  const ranges: [number, number, string][] = [
    [1, 19, 'Capricorn'],
    [2, 18, 'Aquarius'],
    [3, 20, 'Pisces'],
    [4, 19, 'Aries'],
    [5, 20, 'Taurus'],
    [6, 20, 'Gemini'],
    [7, 22, 'Cancer'],
    [8, 22, 'Leo'],
    [9, 22, 'Virgo'],
    [10, 22, 'Libra'],
    [11, 21, 'Scorpio'],
    [12, 21, 'Sagittarius'],
    [12, 31, 'Capricorn'],
  ];

  for (const [m, maxDay, sign] of ranges) {
    if (month < m || (month === m && day <= maxDay)) {
      return sign;
    }
  }

  return '';
}

export function mapForgotPasswordError(err: unknown): string {
  if (isAuthError(err)) {
    switch (err.code) {
      case 'auth/invalid-email':
      case 'auth/missing-email':
        return 'errors.emailInvalid';
      case 'auth/invalid-credential':
      case 'auth/invalid-login-credentials':
        return 'errors.userNotFound';
      case 'auth/network-request-failed':
        return 'errors.networkError';
      case 'auth/too-many-requests':
        return 'errors.tooManyRequests';
      default:
        return 'errors.forgotPasswordFailed';
    }
  }
  return 'errors.forgotPasswordFailed';
}

/** Returns an errors.* i18n key */
export function mapVerificationSendError(err: unknown): string {
  if (isAuthError(err)) {
    switch (err.code) {
      case 'auth/network-request-failed':
        return 'errors.networkError';
      case 'auth/too-many-requests':
        return 'errors.tooManyRequests';
      default:
        return 'errors.verificationSendFailed';
    }
  }
  return 'errors.verificationSendFailed';
}

/** Returns a settings.changeEmail.errors.* key */
export function mapChangeEmailError(err: unknown): string {
  if (isAuthError(err)) {
    switch (err.code) {
      case 'auth/invalid-email':
        return 'changeEmail.errors.emailInvalid';
      case 'auth/email-already-in-use':
        return 'changeEmail.errors.emailInUse';
      case 'auth/requires-recent-login':
        return 'changeEmail.errors.requiresRecentLogin';
      case 'auth/operation-not-allowed':
        return 'changeEmail.errors.notAllowed';
      case 'auth/network-request-failed':
        return 'changeEmail.errors.networkError';
      case 'auth/too-many-requests':
        return 'changeEmail.errors.tooManyRequests';
      default:
        return 'changeEmail.errors.saveFailed';
    }
  }
  return 'changeEmail.errors.saveFailed';
}
